<template>
  <button type="button" class="btn-success-processing">
    <i class="fa-solid fa-sync fa-spin mt-1" />
    <span class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "SuccessButtonProcessing",
  props: ["label"],
};
</script>